import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default function PlayersCountDropdown ({ room, timeSlot, isOpen, onSelect }) {
  if (!isOpen) return null
  const { playersCountingSystem, limitPlayersByGroup } = room
  const { perPlayerPrice, playersCount } = timeSlot
  let maxPlayers = room.maxPlayers

  if (!limitPlayersByGroup && typeof playersCount === 'number') {
    maxPlayers -= playersCount
  }

  const options = useMemo(() => {
    const list = []
    for (let count = room.minPlayers; count <= maxPlayers; count++) {
      list.push(
        <li key={count}>
          <button
            type="button"
            className={`players-count-${count}`}
            onClick={() => { onSelect(count) }}
          >
            {count} - ${Math.round(perPlayerPrice * count)}
          </button>
        </li>
      )
    }
    return list
  }, [room, perPlayerPrice])

  return (
    <div
      className={classNames('select_players_count_dropdown', { 'is-open': isOpen })}
    >
      <div className="title">{playersCountingSystem}:</div>
      <ul className="list">{options}</ul>
    </div>
  )
}

PlayersCountDropdown.propTypes = {
  room: PropTypes.object.isRequired,
  timeSlot: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
}
